import {Box, Typography} from '@mui/material';
import {get_price_str} from 'common';
import {usePrice} from 'hooks/marketHooks';
import {useEffect, useRef, useState} from 'react';
import CryptoSelector from './CryptoSelector';
import ExchangeSelector from './ExchangeSelector';

function PriceIndicator(props: {exchange: string; ticker: string}) {
	const {exchange, ticker} = props;

	const {price, isRefetching, timestamp} = usePrice(exchange, ticker);
	const [price_date, set_price_date] = useState('-');
	const last_price_ref = useRef(0);
	const [is_up, set_is_up] = useState(false);

	useEffect(() => {
		if (timestamp) set_price_date(new Date(timestamp).toLocaleTimeString());

		set_is_up(price >= last_price_ref.current);
		last_price_ref.current = price;
	}, [timestamp]);

	return (
		<Box display="flex" alignItems="center" gap="5px">
			<Box id="fetch-indicator" width="10px" height="10px" borderRadius="50%" bgcolor={isRefetching ? 'primary.main' : 'grey.500'} />
			<Typography variant="body2" color={is_up ? 'secondary' : 'error'}>{`${get_price_str(price, true)}`}</Typography>
			<Typography variant="body2" color="text.disabled">{`${price_date}`}</Typography>
		</Box>
	);
}

export default function MarketInfoBox(props: {exchange: string; ticker: string}) {
	const {exchange, ticker} = props;

	return (
		<Box id="market-info-box" width="100%" display="flex" justifyContent="space-between">
			<Box display="flex" alignItems="center" gap="5px">
				<ExchangeSelector />
				<CryptoSelector />
			</Box>

			<PriceIndicator exchange={exchange} ticker={ticker} />
		</Box>
	);
}
